export const TYPE = {
  AE: '1',
  CM: '2',
}

export const RULE_TYPE = {
  1: '项目规则',
  2: '其他规则',
}
